// extracted by mini-css-extract-plugin
export default {"primaryColor":"#7f5af0","secondaryColor":"#091833","ternaryColor":"#2cb67d","grayColor":"#94a1b2"};